import createComponent, { ComponentProps } from '../utils/createComponent';
export type SidenavHeaderProps = ComponentProps;

/**
 * The `Sidenav.Header` component for use with the `Sidenav` component.
 *
 * @see https://rsuitejs.com/components/sidenav
 */
const SidenavHeader = createComponent({ name: 'SidenavHeader' });

export default SidenavHeader;
